import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';
import {
  useFormContext,
  initialOrderSubmissionContactType,
} from 'modules/client/common/forms/orderSubmissionContactsForm';

import { FormContent } from './FormContent';

export const OrderSubmissionSection = () => {
  const { t } = useTranslation();
  const { readOnly, values, setFieldValue } = useFormContext();

  const onAddOrderSubmissionContact = () => {
    const orderSubmissionContacts = [
      ...values.orderSubmissionContacts,
      {
        type: initialOrderSubmissionContactType,
        value: '',
      },
    ];

    setFieldValue('orderSubmissionContacts', orderSubmissionContacts, false);
  };

  const onRemoveOrderSubmissionContact = (index: number) => {
    const orderSubmissionContacts = [...values.orderSubmissionContacts];
    orderSubmissionContacts.splice(index, 1);
    setFieldValue('orderSubmissionContacts', orderSubmissionContacts, false);
  };

  return (
    <Section
      datax="orderSubmissionSection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAddOrderSubmissionContact}
          />
        )
      }
      title={t('client.client.orderSubmissionContacts.title')}
    >
      <FormContent
        onRemoveOrderSubmissionContact={onRemoveOrderSubmissionContact}
      />
    </Section>
  );
};
